<script setup>
import { defineEmits} from 'vue'
const emit = defineEmits(['create'])
const props = defineProps({
  entityType: String,
  canShow: Boolean
})
</script>

<template>
<!-- <v-btn
    color="primary"
    prepend-icon="mdi-plus"
    @click="emit('create')"
  >
    Create
  </v-btn> -->
  <v-toolbar flat density="comfortable" color="transparent">
    <div>
      <!-- <v-toolbar-title class="font-weight-medium"> -->
        <h1 class="text-h5 font-weight-regular">{{  entityType.toUpperCase() }}</h1>
      <!-- </v-toolbar-title> -->
    </div>

    <v-spacer />

    <v-btn 
    v-if="canShow"
    color="primary" variant="tonal" prepend-icon="mdi-plus" @click="emit('create')">
      Create
    </v-btn>
  </v-toolbar>
</template>